import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GroupService } from "../report-services/group.service";
import { MergeToGroupStudentTableComponent } from "./merge-to-group-student-table/merge-to-group-student-table.component";
import { AddToGroupExistingRequest } from "./shared/AddToGroupExistingRequest";
import { AddToGroupNewRequest } from "./shared/AddToGroupNewRequest";
import { DataService_MergeToGroup } from "./shared/data.service";

@Component({
	selector: "app-merge-to-group-dialog",
	templateUrl: "./merge-to-group-dialog.component.html",
	styleUrls: ["./merge-to-group-dialog.component.css"],
})
export class MergeToGroupDialogComponent implements OnInit {
	constructor(
		public groupService: GroupService,
		private selectService: SchoolselectorService,
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService,
		private mergeToGroupService: DataService_MergeToGroup,

		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		this.lstPerson = this.dialogConfig.data.lstPerson;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		// this.SchoolSubscription = this.selectService
		// .onSchoolChanged()
		// .subscribe(
		//   school => {
		//     this.onSchoolChange(school);
		//   }
		// );

		this.loadSchool();
	}

	// ngOnDestroy(){
	// 	this.SchoolSubscription.unsubscribe();
	// }

	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////////////////

	@ViewChild(MergeToGroupStudentTableComponent)
	tableRef: MergeToGroupStudentTableComponent;

	lstPerson: any = [];

	SchoolID: number = 0;
	LoadingSchool: boolean = false;
	lstSchool: any = [];
	School: any;
	SchoolSubscription: any;

	GroupOption: string = "Existing";

	LoadingGroup: boolean = false;
	lstGroup: any = [];
	SelectedGroup: any;

	AddGroupActions: boolean = false;
	GroupName: string = "";

	Processing: boolean = false;

	errorMessage: any = "";

	///////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////////////////////////////
	loadGroup() {
		this.errorMessage = "";

		if (this.School == undefined) {
			return;
		}

		this.LoadingGroup = true;

		this.lstGroup = [];

		var result = this.groupService.loadGroupList("", this.School.SchoolID);
		result.subscribe(
			(response: any) => {
				this.lstGroup = response;
				this.lstGroup = this.lstGroup.filter((g) => g.GroupID > 0);

				if (this.lstGroup.length > 0) {
					this.SelectedGroup = this.lstGroup[0];
				} else {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "N/A",
					});

					this.SelectedGroup = this.lstGroup[0];
				}

				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	loadSchool() {
		this.errorMessage = "";
		this.LoadingSchool = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response: any) => {
				this.lstSchool = response;
				this.School = this.lstSchool[0];

				if (this.SchoolID > 0) {
					for (var z = 0; z < this.lstSchool.length; z++) {
						var next = this.lstSchool[z];

						if (next.SchoolID == this.SchoolID) {
							this.School = this.lstSchool[z];
						}
					}
				}

				this.LoadingSchool = false;

				this.loadGroup();
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////////////////////////

	onAddToGroup() {
		this.errorMessage = "";

		if (this.GroupOption == "Existing") {
			this.FinishExistingGroup();
		} else if (this.GroupOption == "New") {
			this.FinishNewGroup();
		}
	}

	FinishExistingGroup() {
		if (this.SelectedGroup == null || this.SelectedGroup.GroupID <= 0) {
			this.errorMessage = "Select a group to assign students to";
			return;
		}

		if (this.tableRef.SelectedPersons.length == 0) {
			this.errorMessage = "Select at least one student to merge to a group (Click on the rows to select them)";
			return;
		}

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.tableRef.SelectedPersons.length; z++) {
			var next = this.tableRef.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		this.Processing = true;

		let parms: AddToGroupExistingRequest = {
			GroupID: this.SelectedGroup.GroupID,
			AddGroupActions: this.AddGroupActions == true ? 1 : 0,
			lstPersonIDs: lstPIDs,
		};

		var result = this.mergeToGroupService.AddToGroupExisting(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "merge",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Students were added to the group successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "merge",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add students to the group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishNewGroup() {
		if (this.GroupName == null || this.GroupName == "" || this.GroupName.length == 0) {
			this.errorMessage = "Enter group name to create a new group with the selected students";
			return;
		}

		if (this.tableRef.SelectedPersons.length == 0) {
			this.errorMessage = "Select at least one student to merge to a group (Click on the rows to select them)";
			return;
		}

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.tableRef.SelectedPersons.length; z++) {
			var next = this.tableRef.SelectedPersons[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		this.Processing = true;

		let parms: AddToGroupNewRequest = {
			SchoolID: this.School.SchoolID,
			GroupName: this.GroupName,
			lstPersonIDs: lstPIDs,
		};

		var result = this.mergeToGroupService.AddToGroupNew(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "merge",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Students were added to the group successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "merge",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add students to the group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		if (this.GroupOption == "Existing") {
			this.loadGroup();
		}
	}

	onSelectRow() {
		this.errorMessage = "";
	}

	onGroupOptionChange(val) {
		this.GroupOption = val;

		if (this.GroupOption == "Existing") {
			this.loadGroup();
		}
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingSchool == true || this.LoadingGroup == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////////////////////////////////////////////
}
